<style scoped>
.sticky-top {
    position: -webkit-sticky;
    position: sticky;
    top: 160px;
    z-index: 1;
}
</style> 

<template>
	<v-container class="pa-0">
		<v-toolbar flat class="sticky-top" height="80">
			<v-spacer />
			<v-text-field
				v-model="searchValue"
				@keyup.enter="performSearch"
				@click:prepend-inner="performSearch"
				prepend-inner-icon="mdi-magnify"
				hide-details
				autofocus
				outlined
			></v-text-field>
			<v-spacer />
			<template #extension  v-if="itemList.length > 0">
				<v-spacer />
				<div class="d-flex align-center">
					<span class="text-subtitle-1">{{ $t('ProductSearch.Search_results') }}</span> &nbsp; <span class="text-subtitle-1 font-weight-bold">{{ searchValue }}</span>
					<v-btn icon @click="clearSearch"><v-icon>mdi-close</v-icon></v-btn>
				</div>
				<v-spacer />
			</template>
		</v-toolbar>
		<v-divider  v-if="itemList.length > 0" class="my-2"/>
		<v-row v-if="itemList.length > 0" justify="space-between">
			<v-col cols="12" md="4" lg="3" v-for="(catalogItem, index) of itemList" :key="index"
				align="center">
				<CatalogItemCard :catalogItem="catalogItem" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import CatalogItemCard from "@/components/CatalogItemCard.vue";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
	name: 'ProductSearch',

	components: {
		CatalogItemCard,
	},

	beforeRouteEnter(to, from, next) {
		store.commit("catalog/setItemList", []);
		next();
	},

	data() {
		return {

		};
	},

	computed: {
		searchValue: {
			get() {
				return this.$store.state.catalog.ui.searchText;
			},
			set(value) {
				this.$store.commit("catalog/setSearchText", value);
			},
		},
		...mapGetters({
			itemList: "catalog/itemList",
			loading: "catalog/loading",
			loadMore: "catalog/loadMore",
		}),
	},

	methods: {
		clearSearch() {
			this.$store.commit("catalog/clearSearch");
			this.$router.push({ name: "ProductCatalogHome" });
		},
		performSearch() {
			this.$store.dispatch("catalog/performSearch");
		},
	},
};
</script> 